import React from "react";
import "./AR.scss";

import kiriatas from "../../Media/AboutRuko/Kiri Atas.webp";
import kiribawah from "../../Media/AboutRuko/Kiri Bawah.webp";
import kananatas from "../../Media/AboutRuko/Kanan Atas.webp";
import kananbawah from "../../Media/AboutRuko/Kanan Bawah.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SecondHero = () => {
  return (
    <div className="secondherocontainer" id="ruko">
      <div className="secondmiddle">
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
        <div className="leftcontent">
          <div className="content-judul">
            <h1>Our Ruko Commercials</h1>
            <h2>The Future is Here </h2>
          </div>
          <div className="contentdescription">
            Maksimalkan peluang bisnis Anda dengan ruko komersial strategis di
            kota mandiri Summarecon Serpong, dikelilingi area hunian dan
            fasilitas lengkap. Pilihan tepat untuk ekspansi usaha sekaligus
            investasi properti bernilai tinggi di kawasan berkembang.
          </div>
          <div className="container-benefit">
            <div className="benefit-list">
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Strategic Location
                </span>
              </div>

              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Easy Access
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Flexible Rooms
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Modern & Premium Facillities
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp; Security 24 Hours
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
